export enum FeedbackForFeature {
  AdvancedDeletion = `Advanced Deletion`,
  BehaviorMetrics = `Behavior Metrics`,
  Browse = `Search & Discover`,
  Comments = `Comments`,
  CompactDatePicker = `Date Picker: Compact Variant`,
  Experiments = `Experiments`,
  FeatureFlags = `Feature Flags`,
  FoundationalTemplates = `Foundational Templates`,
  General = `General`,
  HeatMaps = `Heatmaps`,
  Home = `Home`,
  Localization = `Localization`,
  MetricTrees = `Metric Trees`,
  Notifications = `Notifications`,
  SessionReplay = `Session Replay`,
  Spark = `Spark`,
  SparkCopilot = `Spark Copilot`,
  StarterBoard = `Starter Board`,
  TextAnalysis = `Text Analysis`,
  UnifiedDatePicker = `Date Picker: Unified with Presets Bar Variant`,
  WarehouseImports = `Warehouse Imports`,
}

export enum FeedbackType {
  Dealbreaker = `dealbreaker`,
  PainPoint = `pain_point`,
  Beta = `beta`,
  NotWorking = `not_working`,
}

export enum Sentiment {
  Positive = `positive`,
  Negative = `negative`,
}
